import {
  filterDepot,
  isActivityToDisplay,
  isPointDepot,
  featureFilterUnselectedMarker,
} from '../../../../utils/map/MapFeatureFilters';

export function enhanceUnselectedStopGeoJSONFeatures(geoJSON, display, hideVisited) {
  if (!geoJSON?.geo?.features) return geoJSON;

  const depotLocations = geoJSON.geo.features
    .filter((f) => isPointDepot(f) && f.properties.stopLocation)
    .map((s) => s.properties.stopLocation);

  const allFeatures = filterDepot(geoJSON, false);

  const unselectedFeatures = allFeatures.filter((feature) => {
    const isValidPoint =
      feature.geometry.type === 'Point' &&
      !isActivityToDisplay(feature) &&
      featureFilterUnselectedMarker(feature, display, depotLocations);

    return (
      isValidPoint &&
      (!hideVisited ||
        feature.properties.isUnassigned ||
        !feature.properties.routeId ||
        typeof feature.properties.routeId !== 'number')
    );
  });

  return {
    ...geoJSON,
    geo: {
      ...geoJSON.geo,
      features: unselectedFeatures,
    },
  };
}
